/**
 * VMDetectionService is a service class responsible for detecting virtual machines.
 * It utilizes various bridge services to perform tests and log results.
 */
class VMDetectionService {
    /**
     * Constructs the VMDetectionService instance.
     * @param {Object} $q - AngularJS promise service.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} LogBridgeService - Service for logging operations.
     * @param {Object} EventLogBridgeService - Service for event logging.
     * @param {Object} CompCheckBridgeService - Service for running compatibility checks.
     */
    constructor($q, $signals, LogBridgeService, EventLogBridgeService, CompCheckBridgeService) {
        this.$q = $q;
        this.$signals = $signals;
        this.$logger = LogBridgeService;
        this.$eventLog = EventLogBridgeService;
        this.CompCheckBridgeService = CompCheckBridgeService;
        this._logIdentifier = 'VMDetectionService';
        this._isDetected = false;
    }

    /**
     * Initializes the VM detection process.
     * @returns {Promise} A promise that resolves when the detection process is complete.
     */
    init() {
        const d = this.$q.defer();

        this.$logger.info("VM-Detection: starting VM detection");
        this.CompCheckBridgeService.runTest("VmDetection");

        /**
         * Handles the result of the runtime test.
         * @param {string} testname - The name of the test.
         * @param {string} result - The result of the test.
         * @param {string} message - Additional message related to the test result.
         */
        const _runtimeTestResult = (testname, result, message) => {
            if (result !== "PASSED") {
                this.$eventLog.logEvent("a vm was detected", 'VM-Detected', testname + ' ' + result + ' ' + message, '', {});
                this._isDetected = true;
            }
            this.$signals.remove("runtimeTestResult", _runtimeTestResult);
            d.resolve();
        };

        this.$signals.on("runtimeTestResult", _runtimeTestResult);

        return d.promise;
    }

    /**
     * Checks if a virtual machine was detected.
     * @returns {boolean} True if a VM was detected, otherwise false.
     */
    isDetected() {
        return this._isDetected;
    }
}

export default VMDetectionService;